import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import { createGameConfig } from '../game/config';

export default function GameScreen({ onExit }) {
  const containerRef = useRef(null);
  const gameRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || gameRef.current) return;
    const config = createGameConfig(containerRef.current);
    config.type = Phaser.AUTO;
    gameRef.current = new Phaser.Game(config);

    const handleExit = () => onExit && onExit();
    window.addEventListener('neon:exitToMenu', handleExit);

    return () => {
      window.removeEventListener('neon:exitToMenu', handleExit);
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, [onExit]);

  return (
    <div data-testid="game-screen" className="neon-game-wrap">
      <div ref={containerRef} className="neon-game-canvas" />
    </div>
  );
}
